export default __webpack_public_path__ + "static/media/forms-icon.32d0f728.svg";